exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".d1\r\n{\r\n    border:1px solid gray;\r\n\r\n\r\n}\r\n\r\n.p1\r\n{\r\n    border-right: 1px solid gray;\r\n    height:350px;\r\n    width:200px;\r\n}\r\n\r\n.p2\r\n{\r\n    border:1px solid white;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mourtury/mourtury.component.css
// module id = ../../../../../src/app/mourtury/mourtury.component.css
// module chunks = main